import { userFullName } from './chunk-7CF57CJR.mjs';
import { capitalizeEveryWord } from './chunk-YDGMD7UV.mjs';
import { JOINT } from './chunk-4VKGU7BH.mjs';

// helpers/vault.ts
var hasProcessingPlaidFile = (files) => !!files?.some((file) => file.type === "PLAID_REPORT" && file.status === "processing");
var accreditationFilesDisplay = (files, { fallback = "Unspecified", separator = "/" } = {}) => {
  const types = new Set(files?.map((file) => file.type));
  return types.size > 0 ? Array.from(types).map((t) => capitalizeEveryWord(String(t).replace(/_/g, " "))).join(separator) : fallback;
};
var accreditationTypeDisplay = (value, { fallback = "Unspecified" } = {}) => {
  return value ? capitalizeEveryWord(String(value).replace(/_/g, " ")) : fallback;
};
var vaultDisplayName = (vault, options = {}) => {
  if (vault.entity_type === "ENTITY") {
    return vault.company ?? userFullName(vault, options) ?? "Unknown";
  }
  return userFullName(vault, options) ?? "Unknown";
};
var jointInvestmentDisplayName = (records) => {
  const sorted = [...records].sort((a, b) => (b.is_primary ? 1 : 0) - (a.is_primary ? 1 : 0));
  return sorted.map((r) => userFullName(r)).filter(Boolean).join(" & ") || "Unknown";
};
var investmentDisplayName = (investment) => {
  if (investment.vault?.ta_account_type === JOINT && investment.investment_vault_records?.length) {
    return jointInvestmentDisplayName(investment.investment_vault_records);
  }
  return investment.vault?.display_name || "Unknown";
};

export { accreditationFilesDisplay, accreditationTypeDisplay, hasProcessingPlaidFile, investmentDisplayName, jointInvestmentDisplayName, vaultDisplayName };
